// @flow
import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { VerticalCol, VerticalRow } from '../../utils/Grid'
import HousingBox from '../../boxes/HousingBox'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import type { HousingWidgetProps } from '../Types'
import { sendEvent } from '../../utils/googleAnalytics'
import RowWidgetContainer from '../../containers/RowWidgetContainer'

const BoxesContainer = styled(VerticalRow)`
  justify-content: left;
`
const BoxContainer = styled(VerticalCol)`
  margin-right: 46px;
`

export default class Housing extends PureComponent<HousingWidgetProps> {
  render () {
    const {
      props: {
        activeDynamicLayout,
        isOpening,
        isOpen,
        handleToggleContent,
        widget,
        googleAnalytics,
        widget: {
          boxes,
          imageSize = '4_3',
          utmMedium
        }
      }
    } = this

    if (!boxes.length) {
      return null
    }

    const handleAnchorClick = ({ url, position }) => () =>
      sendEvent(googleAnalytics, {
        category: 'Article',
        action: widget.name,
        label: url,
        pozice: position
      })

    return (
      <RowWidgetContainer
        widget={widget}
        isOpening={isOpening}
        activeDynamicLayout={activeDynamicLayout}
        isOpen={isOpen}
        googleAnalytics={googleAnalytics}
        handleToggleContent={handleToggleContent}
      >
        <BoxesContainer>
          {
            boxes.map((box, index) => {
              const {
                annotation,
                guid,
                images,
                link,
                price,
                source,
                title
              } = box

              const image = images[imageSize]

              const utmLink = utmLinkGenerator.createLink(link, {
                utmMedium,
                utmTerm: `position-${boxes.indexOf(box)}`,
                utmCampaign: source
              })

              return (
                <BoxContainer key={guid}>
                  <HousingBox
                    annotation={annotation}
                    image={image}
                    imageClass={`image-${imageSize}`}
                    link={utmLink}
                    price={price}
                    title={title}
                    handleAnchorClick={handleAnchorClick({ url: box.link, position: index + 1 })}
                  />
                </BoxContainer>
              )
            })
          }
        </BoxesContainer>
      </RowWidgetContainer>
    )
  }
}
